export const toLogoFormData = (file, crop, backgroundColor) => {
  const formData = new FormData()
  formData.append(
    'logoDataCreate',
    JSON.stringify({
      cropX: crop.x,
      cropY: crop.y,
      cropWidth: crop.width,
      cropHeight: crop.height,
      backgroundColor
    })
  )
  if (file) {
    formData.append('file', file)
  }
  return formData
}

export const toBackgroundColorFormData = backgroundColor => {
  const formData = new FormData()
  formData.append(
    'logoDataCreate',
    JSON.stringify({
      backgroundColor
    })
  )

  return formData
}
